/**
 * AvtoFix API tip standartlari
 *
 * Barcha REST endpoint'lar shu shaklda javob qaytaradi:
 *   - Muvaffaqiyat: { data, meta? }
 *   - Xato:         { error: { code, message, details? } }
 *
 * Bu yagona haqiqat manbai — boshqa joyda alternative shape bo'lmasligi kerak.
 */
// ─── Type guard'lar ───────────────────────────────────────────────
export function isApiSuccess(res) {
    return 'data' in res;
}
export function isApiError(res) {
    // Defensive: 204 No Content yoki bo'sh body'da res '' / null / undefined
    // bo'lishi mumkin (runtime — tip darajasida ko'rinmaydi) — "'error' in ''"
    // TypeError tashlamasin. unknown'ga cast ESLint type-overlap'ni chetlaydi.
    const r = res;
    if (r === null || typeof r !== 'object')
        return false;
    return 'error' in r;
}
// ─── Standart xato kodlari ────────────────────────────────────────
export const ApiErrorCodes = {
    // Auth
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    // Validation
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    INVALID_INPUT: 'INVALID_INPUT',
    // Resource
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    ALREADY_EXISTS: 'ALREADY_EXISTS',
    // Business logic
    INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
    CUSTOMER_REQUIRED_FOR_DEBT: 'CUSTOMER_REQUIRED_FOR_DEBT',
    CREDIT_LIMIT_EXCEEDED: 'CREDIT_LIMIT_EXCEEDED',
    STORE_LIMIT_REACHED: 'STORE_LIMIT_REACHED',
    // Subscription
    SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
    SUBSCRIPTION_REQUIRED: 'SUBSCRIPTION_REQUIRED',
    // Server
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
};
//# sourceMappingURL=api.types.js.map